import type { LegalAgreement } from "@/Modules/Models/Domain/LegalAgreement";
import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { acceptAgreementTherapist } from "@/Services/TherapyApi/LegalAgreements";

import useAppStore from "@/Modules/App/Store";
import useUserLegalAgreementStore from "@/Modules/LegalAgreement/Store";

import { hasValue } from "@/Utils/Objects";

async function sendLegalAgreementsAH(
  patientId: string,
  legalAgreementUuid: string
): Promise<LegalAgreement | undefined> {
  const appStore = useAppStore();
  const userLegalAgreementsStore = useUserLegalAgreementStore();

  try {
    const la = await acceptAgreementTherapist(legalAgreementUuid);

    if (!hasValue(la)) return undefined;

    await userLegalAgreementsStore.fetchLegalAgreements(patientId);

    appStore.showSnackbar({
      type: NotificationType.SUCCESS,
      message: "chat.settings.customer.legal_agreements.notification.sign_success",
    });

    return la;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "chat.settings.customer.legal_agreements.notification.sign_error",
    });

    return undefined;
  }
}

export default sendLegalAgreementsAH;
